import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './SelectButton.module.css';
import cn from 'classnames'

interface SelectButtonProps {
  label?: string;
  isActive?: boolean;
  onClick: () => void;
  children?: ReactNode;
  theme: string;
}

const SelectButton: React.FC<SelectButtonProps> = ({ label, isActive, onClick, children, theme }) => {

  const wrapperClass = cn(styles.wrapper, {
    [styles.light]: theme === 'light',
    [styles.dark]: theme === 'dark',
  });

  return (
    <button
      className={classNames('text_subheaders_sh3', wrapperClass, {
        [styles.active]: isActive,
      })}
      onClick={onClick}
    >
      {label} {children}
    </button>
  );
};

export default SelectButton;
